/* Engagement events for Meta custom conversions — shared across the r5m LPs.

   Fires guarded fbq trackCustom events, each at most once per pageview:
     ScrollDepth50 / ScrollDepth90  — percent of page height scrolled past
     ReachedBuyBox                  — #r5m-buy entered the viewport (page-length-
                                      independent intent landmark)
     Dwell30s / Dwell60s / Dwell120s — seconds of VISIBLE dwell (timer pauses
                                      while the tab is hidden)
     EngagedVisit                   — composite: 30s visible dwell AND buy box seen

   Lives in an asset rather than an inline <script> because admin theme-editor
   roundtrips strip raw <script> tags out of section markup (see CLAUDE.md).
   The base Meta pixel is loaded externally by the Meta channel app, not the
   theme, so fbq may not exist yet at parse time — every fire is guarded and
   queued until fbq appears (or dropped after 20s). */
(function () {
  'use strict';

  var fired = {};
  var pending = [];
  var params = { page: window.location.pathname };

  function fire(name) {
    if (fired[name]) return;
    fired[name] = true;
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', name, params);
    } else {
      pending.push(name);
    }
  }

  /* Flush queued events once the externally-loaded pixel shows up. */
  var flushTries = 0;
  var flushTimer = setInterval(function () {
    flushTries += 1;
    if (typeof window.fbq === 'function') {
      for (var i = 0; i < pending.length; i += 1) {
        window.fbq('trackCustom', pending[i], params);
      }
      pending = [];
      clearInterval(flushTimer);
    } else if (flushTries >= 40) { /* 20s: pixel blocked or absent — give up */
      clearInterval(flushTimer);
    }
  }, 500);

  /* ─── Scroll depth (percent of full document height) ─── */
  var depthFired = { 50: false, 90: false };
  function checkDepth() {
    var doc = document.documentElement;
    var total = doc.scrollHeight - window.innerHeight;
    if (total <= 0) return;
    var pct = ((window.pageYOffset || doc.scrollTop) / total) * 100;
    if (!depthFired[50] && pct >= 50) { depthFired[50] = true; fire('ScrollDepth50'); }
    if (!depthFired[90] && pct >= 90) { depthFired[90] = true; fire('ScrollDepth90'); }
  }
  window.addEventListener('scroll', checkDepth, { passive: true });

  /* ─── Buy-box landmark ─── */
  var sawBuyBox = false;
  function onBuyBox() {
    if (sawBuyBox) return;
    sawBuyBox = true;
    fire('ReachedBuyBox');
    maybeEngaged();
  }
  function watchBuyBox() {
    /* One selector list covers every LP chassis: r5m pages, meno-belly/brain
       landers, compact-buybox urinary pages, pms-relief, and (fallback) any
       page that renders the standard product form. */
    var buy = document.querySelector('#r5m-buy, #lp-mbl-shop, #lp-compact-buybox, #buy, .product-form-v1');
    if (!buy) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) { onBuyBox(); io.disconnect(); break; }
        }
      }, { threshold: 0.1 });
      io.observe(buy);
    } else {
      /* Fallback: treat 90% scroll as having reached it. */
      window.addEventListener('scroll', function fallback() {
        if (depthFired[90]) { onBuyBox(); window.removeEventListener('scroll', fallback); }
      }, { passive: true });
    }
  }

  /* ─── Visible dwell time ─── */
  var dwell = 0;
  var dwell30 = false;
  setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    dwell += 1;
    if (dwell === 30) { dwell30 = true; fire('Dwell30s'); maybeEngaged(); }
    if (dwell === 60) fire('Dwell60s');
    if (dwell === 120) fire('Dwell120s');
  }, 1000);

  /* ─── Composite qualified-visitor signal ─── */
  function maybeEngaged() {
    if (dwell30 && sawBuyBox) fire('EngagedVisit');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBuyBox);
  } else {
    watchBuyBox();
  }
})();
